import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  greetings: localStorage.getItem('greetings') && JSON.parse(localStorage.getItem('greetings'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/greetings/index.js